module.exports = __webpack_public_path__ + "img/straatmeubilair.b69db1f9.png";